// sort given data in alphabetical order based on given variable type
export function sortAlphabetical(data, type) {
    if (data.length == 0) return [];
    const sortedData = [...data]; // Create a copy to avoid mutation
    if (type === 'name') {
        sortedData.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
    } else if (type === 'email') {
        sortedData.sort((a, b) => a.email.localeCompare(b.email, undefined, { sensitivity: 'base' }));
    } else {
        sortedData.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
    }
    return sortedData;
}

export function findArrayIndex(arrayToCheck, checkValue) { // find if an element already exists in a given array
    return arrayToCheck.findIndex(item => item === checkValue);
}